<template>
  <div class="faq" @click="opened = !opened" ref="faq">
    <div class="faq__top">
      <p ref="question" class="faq__question">
        {{ question }}
        <svg
          class="faq__icon"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            :d="opened ? 'M10 10H20H1' : 'M10 19V10M10 10V1M10 10H19M10 10H1'"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </p>
    </div>
    <div ref="answers" class="faq__bottom" v-html="answer"></div>
  </div>
</template>

<script>
export default {
  name: "PFAQ",
  props: ["question", "answer"],
  data() {
    return {
      opened: false,
      oldHeight: 0
    };
  },
  mounted() {
    this.oldHeight = this.$refs["question"].offsetHeight + 30;
    this.$refs["faq"].style.maxHeight = `${this.oldHeight}px`;
  },
  watch: {
    opened(value) {
      if (value) {
        this.$refs["faq"].style.maxHeight = `${this.oldHeight +
          this.$refs["answers"].offsetHeight +
          20}px`;
        this.GAEvent("faq_click", "click_text", this.question);
      } else {
        this.$refs["faq"].style.maxHeight = `${this.oldHeight}px`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/vars";
.faq {
  border: 1px solid #cccccc;
  border-radius: 5px;
  padding: 15px 30px 20px;
  position: relative;
  max-height: 55px;
  overflow: hidden;
  margin-bottom: 15px;
  transition: max-height 200ms ease;
  cursor: pointer;
  @media #{$mobile} {
    padding: 15px 22px 20px;
  }

  &__question {
    font-weight: 600;
    line-height: 140%;
    margin-bottom: 20px;
    padding: 0;
    margin-top: 0;
    position: relative;
    @media #{$mobile} {
      font-size: 15px;
      padding-right: 30px;
    }
  }

  &__icon {
    position: absolute;
    right: -10px;
    top: calc(50% - 10px);
  }
}
</style>
